<template>
  <createsalesreturn />
</template>

<script>
import createsalesreturn from "./createsalesreturn.vue";

export default {
  name: "editsalesreturn",
  components: { createsalesreturn },
};
</script>
